<app-tables
  [tableHeader]="'Patient Report'"
  [data]="data"
  [totalCount]="totalCount"
  [columns]="columns"
  [filters]="filters"
  (onChangeFilterValues)="onChangeFilterValues($event)"
  [totalPage]="totalPage"
></app-tables>
